import { createFileRoute, redirect } from '@tanstack/react-router';
import { getSession } from '../../../lib/session';
import { usePageTitle } from '../../../lib/hooks';
import { HealthDashboard } from '../../../features/admin/health/HealthDashboard';

function AdminHealthRoute() {
  usePageTitle('System Health');
  return <HealthDashboard />;
}

export const Route = createFileRoute('/_auth/admin/health')({
  beforeLoad: ({ location }) => {
    const session = getSession();
    const isAllowed =
      session?.user.type === 'group_admin' ||
      session?.user.type === 'company_admin' ||
      session?.permissions.includes('admin.health.read');

    if (!isAllowed) {
      throw redirect({
        to: '/',
        search: { callbackUrl: location.href },
      });
    }
  },
  component: AdminHealthRoute,
});
